import { render } from "./TestimonialSection.vue?vue&type=template&id=47d7572d"
import script from "./TestimonialSection.vue?vue&type=script&lang=js"
export * from "./TestimonialSection.vue?vue&type=script&lang=js"

import "./TestimonialSection.vue?vue&type=style&index=0&id=47d7572d&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__